import { render, staticRenderFns } from "./KosmoRules.vue?vue&type=template&id=e8d677f6"
import script from "./KosmoRules.vue?vue&type=script&lang=js"
export * from "./KosmoRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports